import BaseService from '@/ecm/common/BaseService.js';

class DashboardService {
  baseUrl = 'dashboard';

  getOrganizationDashboard = (orgID) => BaseService.get({ url: `${this.baseUrl}/organization/${orgID}` });
  getDocumentsDashboard = (filter) => BaseService.post({ url: `${this.baseUrl}/documents`, data: filter });
  getPublicDashboardUsers = () => BaseService.get({ url: `${this.baseUrl}/public-dashboards-users` })
}

export default new DashboardService();
